import React, { useState } from "react";

const ProposalRequest = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    associationName: "",
    totalHomes: "",
    communityType: "",
    professionallyManaged: "",
    contractExpiration: "",
    serviceType: "",
    boardPosition: "",
    communityDescription: "",
    reserveStudyDate: "",
    boardMeetingFrequency: "",
    assessmentBillingFrequency: "",
    litigation: "",
    constructionProjects: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted:", formData);
    alert("Your proposal request has been submitted!");
  };

  return (
    <section className="contact-wrapper">
      <div className="container contact-form-block contact-form-modern">
        
        <h2 className="contact-form-title">Proposal Request</h2>

        <form onSubmit={handleSubmit}>

          {/* FIRST & LAST NAME */}
          <div className="row">
            <div className="col-lg-6 col-12">
              <div className="form-floating-field">
                <input
                  type="text"
                  name="firstName"
                  placeholder=" "
                  value={formData.firstName}
                  onChange={handleChange}
                />
                <label>First Name</label>
              </div>
            </div>

            <div className="col-lg-6 col-12">
              <div className="form-floating-field">
                <input
                  type="text"
                  name="lastName"
                  placeholder=" "
                  value={formData.lastName}
                  onChange={handleChange}
                />
                <label>Last Name</label>
              </div>
            </div>
          </div>

          {/* EMAIL & PHONE */}
          <div className="row">
            <div className="col-lg-6 col-12">
              <div className="form-floating-field">
                <input
                  type="email"
                  name="email"
                  placeholder=" "
                  value={formData.email}
                  onChange={handleChange}
                />
                <label>Email Address</label>
              </div>
            </div>

            <div className="col-lg-6 col-12">
              <div className="form-floating-field">
                <input
                  type="text"
                  name="phone"
                  placeholder=" "
                  value={formData.phone}
                  onChange={handleChange}
                />
                <label>Phone Number</label>
              </div>
            </div>
          </div>

          {/* ASSOCIATION NAME */}
          <div className="form-floating-field">
            <input
              type="text"
              name="associationName"
              placeholder=" "
              value={formData.associationName}
              onChange={handleChange}
            />
            <label>Association Legal Name & Address</label>
          </div>

          {/* TOTAL HOMES + COMMUNITY TYPE */}
          <div className="row">
            <div className="col-lg-6 col-12">
              <div className="form-floating-field">
                <input
                  type="text"
                  name="totalHomes"
                  placeholder=" "
                  value={formData.totalHomes}
                  onChange={handleChange}
                />
                <label>Total Number of Homes</label>
              </div>
            </div>

            <div className="col-lg-6 col-12">
              <div className="form-floating-field">
                <input
                  type="text"
                  name="communityType"
                  placeholder=" "
                  value={formData.communityType}
                  onChange={handleChange}
                />
                <label>Community Type (SF, TH, Condo, Etc.)</label>
              </div>
            </div>
          </div>

          {/* PROFESSIONALLY MANAGED */}
          <div className="form-floating-field">
            <select
              name="professionallyManaged"
              value={formData.professionallyManaged}
              onChange={handleChange}
            >
              <option value=""></option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <label>Is the association professionally managed?</label>
          </div>

          {/* CONTRACT EXPIRATION */}
          <div className="form-floating-field">
            <input
              type="date"
              name="contractExpiration"
              placeholder=" "
              value={formData.contractExpiration}
              onChange={handleChange}
            />
            <label>Expiration date of current contract</label>
          </div>

          {/* SERVICE TYPE */}
          <div className="form-floating-field">
            <select
              name="serviceType"
              value={formData.serviceType}
              onChange={handleChange}
            >
              <option value=""></option>
              <option value="Full Service">Full Service</option>
              <option value="Financial Management Services">Financial Management Services</option>
            </select>
            <label>Management Services Desired</label>
          </div>

          {/* BOARD POSITION */}
          <div className="form-floating-field">
            <input
              type="text"
              name="boardPosition"
              placeholder=" "
              value={formData.boardPosition}
              onChange={handleChange}
            />
            <label>If you are a Board Member, indicate your position</label>
          </div>

          {/* DESCRIPTION */}
          <div className="form-floating-field">
            <textarea
              name="communityDescription"
              placeholder=" "
              value={formData.communityDescription}
              onChange={handleChange}
            ></textarea>
            <label>Describe your community here</label>
          </div>

          {/* RESERVE STUDY */}
          <div className="form-floating-field">
            <input
              type="text"
              name="reserveStudyDate"
              placeholder=" "
              value={formData.reserveStudyDate}
              onChange={handleChange}
            />
            <label>Date of last reserve study</label>
          </div>

          {/* MEETING FREQUENCY */}
          <div className="form-floating-field">
            <input
              type="text"
              name="boardMeetingFrequency"
              placeholder=" "
              value={formData.boardMeetingFrequency}
              onChange={handleChange}
            />
            <label>Frequency of Board Meetings</label>
          </div>

          {/* ASSESSMENT BILLING */}
          <div className="form-floating-field">
            <input
              type="text"
              name="assessmentBillingFrequency"
              placeholder=" "
              value={formData.assessmentBillingFrequency}
              onChange={handleChange}
            />
            <label>Frequency of assessment billing</label>
          </div>

          {/* LITIGATION */}
          <div className="form-floating-field">
            <input
              type="text"
              name="litigation"
              placeholder=" "
              value={formData.litigation}
              onChange={handleChange}
            />
            <label>Current litigation, if any</label>
          </div>

          {/* CONSTRUCTION PROJECTS */}
          <div className="form-floating-field">
            <input
              type="text"
              name="constructionProjects"
              placeholder=" "
              value={formData.constructionProjects}
              onChange={handleChange}
            />
            <label>Current or pending construction projects</label>
          </div>

          {/* SUBMIT BUTTON */}
          <button type="submit" className="primary-btn" style={{ marginTop: "20px" }}>
            Submit Proposal Request
          </button>

        </form>
      </div>
    </section>
  );
};

export default ProposalRequest;
